import { useCallback, useEffect, useRef, useState } from "react";
import { getErrorMessage } from "../utils/errors";

export default function useAsync(asyncFn, deps = [], { skip = false } = {}) {
  const [state, setState] = useState({ loading: !skip, error: null, data: null });
  const callId = useRef(0);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(asyncFn, deps);

  const reload = useCallback(async () => {
    if (skip) return;
    callId.current += 1;
    const id = callId.current;
    const current = () => mounted.current && id === callId.current;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const res = await run();
      if (current()) setState({ loading: false, error: null, data: res && "data" in res ? res.data : res });
    } catch (err) {
      if (current()) setState({ loading: false, error: getErrorMessage(err), data: null });
    }
  }, [run, skip]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...state, reload };
}
